// Directly reference and pull in styling from stub,
// that is commented out in production to elimited 'fake'
// stub javascript while having single source of truth for LESS
require("../stubs/notificationPreferences/notificationPreferences.less");
import "./notificationPreferences.js";
import "./notificationPreferenceDetailsPage.js";


// WEBPACK FOOTER //
// ./src/pages/notificationPreferences/index.js